/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import { Box } from '@mui/material';
import { NotificationSeverity, NotificationSource } from '@poweralpha/common';
import { getGlyphTileSx } from './styles';

const sourceIcons = {
  [NotificationSource.SIMULATION]: BoltOutlinedIcon,
  [NotificationSource.BATCH]: LayersOutlinedIcon,
  [NotificationSource.BID_REQUEST]: DescriptionOutlinedIcon,
  [NotificationSource.AGENT]: SmartToyOutlinedIcon,
  [NotificationSource.RECORDS]: StorageOutlinedIcon,
};

interface Props {
  source: NotificationSource | undefined;
  severity: NotificationSeverity;
  size?: number;
}

/** Neutral source icon on a tile; severity shows as a corner badge (none for info). */
function NotificationGlyph({ source, severity, size = 32 }: Readonly<Props>) {
  const Icon = sourceIcons[source ?? NotificationSource.SIMULATION];
  return (
    <Box sx={getGlyphTileSx(size)} data-severity={severity}>
      <Icon sx={{ fontSize: Math.round(size / 2) }} />
      {severity !== NotificationSeverity.INFO && (
        <Box
          aria-hidden
          sx={{
            position: 'absolute',
            top: -3,
            right: -3,
            width: 10,
            height: 10,
            borderRadius: '50%',
            bgcolor: `${severity}.main`,
            boxShadow: (theme) => `0 0 0 2px ${theme.palette.background.paper}`,
          }}
        />
      )}
    </Box>
  );
}

export default NotificationGlyph;
